/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

export const eventEnumSchema = z
	.enum(["payment.waiting_for_capture", "payment.succeeded", "payment.canceled", "refund.succeeded"])
	.describe(
		"* `payment.waiting_for_capture` - Ожидает оплаты\n* `payment.succeeded` - Успешно завершен\n* `payment.canceled` - Отменен\n* `refund.succeeded` - Успешный возврат",
	);
